import { Address } from '../address/address';
import { RoomPreview } from '../property/room-preview';

export class FindHomeSearchResult {
    majorAddresses: Address[];
    minorAddresses: Address[];
    roomPreviews: RoomPreview[];
}
